import { useEffect, useState, useCallback } from "react";
import { Search, Download } from "lucide-react";
import { api } from "../lib/api";
import { AdminCustomerFiche } from "./AdminCustomerFiche";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [ficheId, setFicheId] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/customers", { params: search ? { search } : {} }).then((r) => setCustomers(r.data)).catch(() => {});
  }, [search]);

  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  const exportCsv = () => {
    const rows = [["Prénom", "Nom", "Email", "Téléphone", "Inscription"], ...customers.map((c) => [c.first_name, c.last_name, c.email, c.phone || "", c.created_at?.split("T")[0] || ""])];
    const csv = rows.map((r) => r.map((v) => `"${(v || "").toString().replace(/"/g, '""')}"`).join(";")).join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "clients-italian-club.csv";
    a.click();
  };

  return (
    <div data-testid="admin-customers">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif-elegant text-3xl font-bold">Clients</h1>
        <button data-testid="customers-export-btn" onClick={exportCsv} className="btn-outline-gold !py-2 text-sm"><Download size={15} /> Exporter CSV</button>
      </div>
      <div className="relative mb-6 max-w-md">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
        <input data-testid="customers-search" className="ic-input !pl-11" placeholder="Rechercher par nom, email ou téléphone…" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>
      <div className="ic-card !transform-none overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/10 text-left">
              <th className="p-4 gold-label">Client</th>
              <th className="p-4 gold-label">Email</th>
              <th className="p-4 gold-label">Téléphone</th>
              <th className="p-4 gold-label">Inscription</th>
              <th className="p-4 gold-label">RGPD</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className="border-b border-white/5 cursor-pointer hover:bg-white/5 transition-colors" data-testid={`customer-row-${c.id}`} onClick={() => setFicheId(c.id)}>
                <td className="p-4 font-medium">{c.first_name} {c.last_name}</td>
                <td className="p-4 text-gray-400">{c.email}</td>
                <td className="p-4 text-gray-400">{c.phone || "—"}</td>
                <td className="p-4 text-gray-500">{c.created_at?.split("T")[0]}</td>
                <td className="p-4 text-xs">
                  <span className={c.consent_email ? "text-[#009246]" : "text-gray-600"}>Email</span>
                  {" · "}
                  <span className={c.consent_sms ? "text-[#009246]" : "text-gray-600"}>SMS</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <p className="p-6 text-gray-500">Aucun client trouvé.</p>}
      </div>
      <p className="text-xs text-gray-600 mt-3">Cliquez sur un client pour ouvrir sa fiche détaillée (consentements RGPD, notes, historique, suppression des données).</p>
      {ficheId && <AdminCustomerFiche userId={ficheId} onClose={() => setFicheId(null)} onChanged={load} />}
    </div>
  );
}
